<template>
  <section id="blog" class="n2-seccion" v-if="B?.Mostrar && articulos.length">
    <div class="n2-contenedor">
      <div class="n5-cabeza n2-aparece">
        <div>
          <span v-if="etiqueta" class="n5-etiqueta">{{ etiqueta }}</span>
          <h2 class="n5-titulo" v-html="B.Titulo?.Texto || porDefecto"></h2>
          <div v-if="B.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(B.Descripcion.css)" v-html="B.Descripcion.Texto"></div>
        </div>
        <NuxtLink v-if="NOTARIA.Theme.Menu?.ShowBlog" :to="getLocalePath('/blog')" class="n2-enlace">{{ tSolicitud('Ver todos') }} <span aria-hidden="true">→</span></NuxtLink>
      </div>
      <div class="n5-blog__lista">
        <NuxtLink v-for="a in articulos" :key="a.id" :to="getLocalePath('/blog/' + a.Slug)" class="n5-articulo n2-aparece">
          <img :src="imagenIDtoSRC(a.Imagen)" :alt="a.Titulo" loading="lazy" />
          <div>
            <time v-if="fechaNotin(a.Fecha)">{{ formatoFecha(a.Fecha) }}</time>
            <h3>{{ a.Titulo }}</h3>
            <p>{{ textoPlano(a.Extracto || a.Contenido, 220) }}</p>
          </div>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud, idiomaSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, textoPlano, fechaNotin, alineacionTexto } from '../../composables/useNotaria2'
import { etiquetaSeccion } from '../../composables/useNotaria5'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
// Panel: Inicio → Blog, y los artículos publicados con "Mostrar en inicio" e imagen
const B = computed(() => NOTARIA.value?.Theme?.Home?.Blog)
const articulos = computed(() => (NOTARIA.value?.Blog ?? [])
  .filter(a => a.Publicado && a.MostrarHome && a.Imagen)
  .sort((a, b) => fechaNotin(b.Fecha) - fechaNotin(a.Fecha))
  .slice(0, 5))
const porDefecto = computed(() => tituloSeccion(NOTARIA.value, 'Blog', $t))
const etiqueta = computed(() => etiquetaSeccion(B.value?.Titulo?.Texto, porDefecto.value))
const formatoFecha = (f) => new Date(fechaNotin(f)).toLocaleDateString(idiomaSolicitud.value, { year: 'numeric', month: 'long', day: 'numeric' })
</script>
